var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 104,
    viewBox: "0 0 114 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_10179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.80127 25.7227V74.9385C0.80127 75.9482 1.34111 76.8879 2.22086 77.3878L43.419 101.181C44.2987 101.691 45.3784 101.691 46.2482 101.181L87.4463 77.3878C88.326 76.8779 88.8659 75.9482 88.8659 74.9385V25.7227L44.8286 51.1453L0.80127 25.7227Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.80127 25.7227L44.8386 0.300049L88.8759 25.7227L44.8386 51.1554L0.80127 25.7227Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8064 35.5497L61.8337 10.1271L71.7508 15.8554L27.7135 41.2881L27.6935 60.3226L17.7964 54.6142L17.8064 35.5497Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8384 51.1553V101.321",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4801 82.6462V91.0538L23.3345 82.1463V73.7388L38.4801 82.6462Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.756 104C102.421 104 113.499 92.9223 113.499 79.2571C113.499 65.592 102.421 54.5143 88.756 54.5143C75.0909 54.5143 64.0132 65.592 64.0132 79.2571C64.0132 92.9223 75.0909 104 88.756 104Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.704 77.1377H81.808C80.7148 77.1377 79.8286 78.0239 79.8286 79.1171V86.0651C79.8286 87.1583 80.7148 88.0445 81.808 88.0445H95.704C96.7972 88.0445 97.6835 87.1583 97.6835 86.0651V79.1171C97.6835 78.0239 96.7972 77.1377 95.704 77.1377Z",
    stroke: "white",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7974 77.1378V73.1689C83.7974 70.4297 86.0167 68.2103 88.7559 68.2103C91.4951 68.2103 93.7145 70.4297 93.7145 73.1689V77.1378",
    stroke: "white",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_10179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.997,
    height: 104,
    fill: "white",
    transform: "translate(0.501465)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeized);
export default __webpack_public_path__ + "static/media/seized.82ba7ff927fb2520373b8c0ead8458fb.svg";
export { ForwardRef as ReactComponent };